import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Спортивная майка - "борцовка". Круглый вырез. Плотность 180г/м². Состав: 95% хлопок, 5% эластан.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`tanktop`],
      sizeInfo: `tanktop`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
